module.exports = __webpack_public_path__ + "static/media/angle-double-down.e31704e8.svg";